import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const schema = z.object({
  name: z.string().min(1),
})

export type CreateListFormValues = z.infer<typeof schema>

export const CREATE_LIST_FORM_ID = 'create-list-form'
export const createListFormResolver = zodResolver(schema)
